import { V1 } from './net'
import { StoreThunkDispatch } from 'store/state'
import { ContentType } from 'interfaces'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { action, message } from 'services/snackbar'

const RESTORE_POSTS_DURATION = 10000

export function bulkDeletePosts(
  ids: string[],
  pageIds: string[],
  type: 'queued' | 'pending' | 'scheduled' | 'failed' | 'planned',
  all?: boolean,
  bucketId?: string,
  query?: string,
  types?: ContentType[],
  source?: 'bucket' | 'no-bucket',
  onRestored?: () => any
) {
  return (dispatch: StoreThunkDispatch) => {
    return dispatch(V1.deletePosts(ids, pageIds, type, all, bucketId, query, types, source))
      .do({
        next: (response) => {
          if (response.error) {
            throw new Error(response.error)
          } else if (onRestored) {
            const deletedPostIds = response.deletedPostIds?.map((id: any) => id.toString()) || ids
            const msg = `You deleted ${deletedPostIds.length} ${deletedPostIds.length === 1 ? 'post' : 'posts'}.`
            dispatch(action('info', msg, 'Restore posts', () => {
              dispatch(restoreDeletedPosts(deletedPostIds))
                .unwrap()
                .catch((e: any) => {
                  setTimeout(() => {
                    dispatch(message('Failed to restore posts: ' + e.message, 'error'))
                  })
                })
                .finally(onRestored)
            }, RESTORE_POSTS_DURATION, { horizontal: 'right', vertical: 'bottom' }))
          }
        }
      })
      .map(() => ({ ids }))
  }
}

export const restoreDeletedPosts = createAsyncThunk(
  'posts/restoreDeletedPosts',
  async (ids: string[], { dispatch }) => {
    const response = await dispatch(V1.restoreDeletedPosts(ids)).toPromise()
    if (response.error) {
      throw new Error(response.error)
    }
    return { ids }
  }
)
